import ActionCreator from "../actionCreator";

export default {
    enqueueSnackbar: ActionCreator("SNACKBAR_ENQUEUE"),
    removeSnackbar: ActionCreator("SNACKBAR_REMOVE"),
    dismissSnackbar: ActionCreator("SNACKBAR_DISMISS"),
    reset: ActionCreator("SNACKBAR_RESET"),
};
